import Vue from 'vue';
import tml from './messageBox.vue';

var _MessageBox = Vue.extend(tml);
var instance = '';

var MessageBox = function(options){
  var options = options || {};

  instance = new _MessageBox({
    'propsData': options
  });

  instance.vm = instance.$mount();

  document.body.appendChild(instance.vm.$el);
  return instance.vm;
};

export default MessageBox;


// WEBPACK FOOTER //
// ./src/components/messageBox/messageBox.js